<mat-form-field appearance="outline">
    <mat-select placeholder="E-Invoice" [(ngModel)]="eInvBtn"
     (selectionChange)="selectEInvoice(eInvBtn)">
        <mat-option *ngFor="let item of eInvArr" [value]="item.value">
            {{item.key}}
        </mat-option>
    </mat-select>
</mat-form-field>

<div class="col-md-12" [hidden]="!showPdf">
    <pdf-viewer [src]="base64String" [render-text]="true" [show-all]="true" [original-size]="false" [zoom]="1"
        style="height: 400px;width: 100%;"></pdf-viewer>
</div>